import Vue from "vue";
import VueI18n from "vue-i18n";
import english from "@/languages/english";

Vue.use(VueI18n);

const messages = {
  en: english
};

//@ts-ignore
const i18n = new VueI18n({ locale: "en", fallbackLocale: "es", messages });

export default i18n;
